//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "integralhistorydetail"
}



// WEBPACK FOOTER //
// ./src/components/integralhistorydetail/integralhistorydetail.vue